/**
 * @generated SignedSource<<b2f347b6f86114c24b369b99a5ac19f5>>
 * @relayHash 6846c2b353d52935ffcd97c0c83888da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd6752d7ca61f340baeb3c609b862f187f8cf5af8c22d46be5786ce68d776813

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainVirtualServiceAgentCtaCardQuery$variables = {
  checkForAiEnabledFF: boolean;
  cloudId: string;
  key: string;
};
export type mainVirtualServiceAgentCtaCardQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isVirtualAgentEnabled: boolean | null | undefined;
      readonly knowledgeBaseArticlesCount: {
        readonly count?: number;
      };
      readonly virtualAgentConfiguration: {
        readonly __typename: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly isAiEnabledInAdminHub?: boolean | null | undefined;
      readonly isVirtualAgentAvailable: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type mainVirtualServiceAgentCtaCardQuery = {
  response: mainVirtualServiceAgentCtaCardQuery$data;
  variables: mainVirtualServiceAgentCtaCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkForAiEnabledFF"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v5 = [
  (v3/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "count"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "isVirtualAgentEnabled"
},
v9 = {
  "concreteType": "VirtualAgentQueryApi",
  "kind": "LinkedField",
  "name": "virtualAgent",
  "plural": false,
  "selections": [
    {
      "args": (v5/*: any*/),
      "concreteType": "VirtualAgentFeatures",
      "kind": "LinkedField",
      "name": "virtualAgentEntitlements",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isVirtualAgentAvailable"
        },
        {
          "condition": "checkForAiEnabledFF",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isAiEnabledInAdminHub"
            }
          ]
        }
      ]
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainVirtualServiceAgentCtaCardQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "args": (v5/*: any*/),
                  "kind": "LinkedField",
                  "name": "knowledgeBaseArticlesCount",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v6/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProjectByKey.knowledgeBaseArticlesCount.count"
                        }
                      ],
                      "type": "KnowledgeBaseArticleCountSource"
                    }
                  ]
                },
                "action": "THROW",
                "path": "jira.jiraProjectByKey.knowledgeBaseArticlesCount"
              },
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ]
              },
              (v8/*: any*/)
            ]
          }
        ]
      },
      (v9/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainVirtualServiceAgentCtaCardQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v5/*: any*/),
                "kind": "LinkedField",
                "name": "knowledgeBaseArticlesCount",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "KnowledgeBaseArticleCountSource"
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "virtualAgentConfiguration",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "VirtualAgentQueryError"
                  }
                ]
              },
              (v8/*: any*/),
              (v10/*: any*/)
            ]
          }
        ]
      },
      (v9/*: any*/)
    ]
  },
  "params": {
    "id": "dd6752d7ca61f340baeb3c609b862f187f8cf5af8c22d46be5786ce68d776813",
    "metadata": {},
    "name": "mainVirtualServiceAgentCtaCardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9989db7de5f26bbca549027d2509feb6";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
